/// <amd-module name="Search/Code/Help/Constants" />

export const SearchHelpFilterActivated = "SearchHelpFilterActivated";
export const CodeEntity = "code";